import React from 'react';
import { Handle, Position } from '@xyflow/react';

function AppServiceNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-sky-500 bg-sky-50/70 dark:bg-sky-900/30'
          : 'border-sky-300 bg-sky-50/40 dark:bg-sky-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-sky-500" />
      <div className="mb-1 flex items-center gap-2">
        <svg className="h-4 w-4 text-sky-600 dark:text-sky-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <path d="M12 2L2 7l10 5 10-5-10-5z" />
          <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
        <span className="text-sm font-semibold text-sky-900 dark:text-sky-100 truncate">{data.name}</span>
      </div>
      {data.appRuntime && (
        <span className="inline-block bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.appOsType} / {data.appRuntime}
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">App Service</div>
      <Handle type="source" position={Position.Bottom} className="!bg-sky-500" />
    </div>
  );
}

export default AppServiceNode;
